module.exports = __webpack_public_path__ + "assets/img/60f579a505996bfb2323f2611698e934.png";